import { SymbolCategoryId } from "./types";

export const DEFAULT_SYMBOL_SIZE = 20;

export const DEFAULT_SYMBOL_WITH_BG_SIZE = 24;

export const MAX_SYMBOL_SIZE = 32;

export const DEFAULT_SYMBOL_FILL_COLOR = "rgba(0, 163, 245, 1)";

export const DEFAULT_SYMBOL_STROKE_COLOR = "rgb(255, 255, 255)";

export const SYMBOL_TOP_CATEGORIES = [SymbolCategoryId.Simple, SymbolCategoryId.Themed, SymbolCategoryId.Analytic];

export const DEFAULT_H3_SYMBOL = {
  type: "h3grid",
  cellSize: 7,
  disabled: false,
  stroke: {
    type: "solid",
    color: "#ffffff84",
    width: 2,
  },
  fill: {
    type: "solid",
    color: {
      type: "byAttribute",
      defaultValue: "#7a5e9080",
      title: null,
      values: [
        {
          title: null,
          condition: "(gid <= 10)",
          value: "#f7fbffff",
        },
        {
          title: null,
          condition: "(gid > 10) && (gid <= 50)",
          value: "#deebf7ff",
        },
        {
          title: null,
          condition: "(gid > 50) && (gid <= 100)",
          value: "#c6dbefff",
        },
        {
          title: null,
          condition: "(gid > 100) && (gid <= 500)",
          value: "#9ecae1ff",
        },
        {
          title: null,
          condition: "(gid > 500) && (gid <= 1000)",
          value: "#6baed6ff",
        },
        {
          title: null,
          condition: "(gid > 1000) && (gid <= 5000)",
          value: "#4292c6ff",
        },
        {
          title: null,
          condition: "(gid > 5000)",
          value: "#08519cff",
        },
      ],
    },
  },
  aggregations: [
    {
      attributeName: "gid",
      alias: null,
      description: null,
      aggregationFunction: "Count",
    },
  ],
};
